import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({ name: 'CmgFavoriteRestaurantModal' })
export default class CmgFavoriteNameModal extends Vue {
  nicknameValue = '';
  nicknameError = false;

  get heartIconUrl(): string {
    return this.$appStore.state.cms.images.icons.heartFilled.default;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.favoriteRestaurant.visible;
  }

  get restaurantNumber(): number | undefined {
    const modalArgs = this.$appStore.state.ui.modals.favoriteRestaurant.args;
    if (!modalArgs) {
      return;
    }

    return modalArgs.restaurantNumber;
  }

  @Watch('visible', { immediate: false })
  onRestaurantLocationChanged(newVisible: boolean) {
    if (newVisible === false) {
      this.nicknameValue = '';
      this.nicknameError = false;
    }
  }

  onNicknameInput(value: string) {
    this.nicknameValue = value;
  }

  setFavorite() {
    if (!this.restaurantNumber) {
      // TODO-wccabp: handle error
      this.$services.logger.unreachable('Somehow tried to favorite a restaurant without an assigned number!');

      return;
    }

    this.$services.customer.addFavoriteRestaurant(this.restaurantNumber, this.nicknameValue);
  }

  onSubmit() {
    if (this.nicknameValue != '') {
      this.setFavorite();
      this.onCancel();
    } else {
      this.nicknameError = true;
    }
  }

  onCancel() {
    this.$services.ui.setModalVisibility('favoriteRestaurant', false);
    this.$services.ui.focusBack();
  }
}
